import React, { PropsWithChildren, createContext, useCallback, useState, useEffect, useRef } from "react";
import { deleteRule, getRuleItem, getRuleList, saveRule, updateRule } from "../../service";
import { TLogicRule, TNode, TSelectedObj, TSidePanelData } from "../RuleComponents/dataTypes";
import { FIELD_TYPES, NODE_TYPES, } from "../RuleComponents/constants";
import { toast } from "react-toastify";


export const SB3RuleContext = createContext<any>(undefined);

export const SB3RuleContextProvider = ({ children }: PropsWithChildren) => {
    const [modelData, setModelData] = useState({})
    const [sidePaneldata, setSidePanelData] = useState<TSidePanelData[]>()
    const [selectedIds, setSelectedIds] = useState<TNode[]>([])
    const [sidepanelType, setSidepanelType] = useState<string>("regular")
    const [filteredData, setFilteredData] = useState<TSidePanelData[]>()
    const [showPickPanel, setShowPickPanel] = useState<boolean>(false)
    const [showTarget, setShowTarget] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [logicRule, setLogicRule] = useState<TLogicRule>(
        {
            name: "",
            description: "",
            rule_type: "logic",
            rule: {
                source: [],
                constraint: "Includes",
                target: {
                    operator: "all_true",
                    conditions: [],
                },
            },
        }
    )

    const [showRulesMenu, setShowRulesMenu] = useState(false)
    const updateLogicRule = (data: any) => {
        setLogicRule(data)
    }

    const resetLogicRule = () => {
        hidePickPanel()
        setSelectedIds([])
        setLogicRule({
            name: "",
            description: "",
            rule_type: "logic",
            rule: {
                source: [],
                constraint: "Includes",
                target: {
                    operator: "all_true",
                    conditions: [

                    ],
                },
            },
        })
    }

    const toggleMenu = (id: string | null = null) => {
        setShowRulesMenu(prev => {
            return !prev
        })
        if (id !== undefined && id !== null && id !== '') {
            console.log(id, "DASA")
            getRule(id)
            setShowTarget(true)
        } else {
            resetLogicRule()
            setShowTarget(false)
        }
    }
    const [selectedObj, setSelectedObj] = useState<TSelectedObj>(
        {
            selectedRootIndex: 0,
            type: 'source',
            selectedConditionIndex: 0
        }
    )

    const logicRuleRef = useRef(logicRule);

    useEffect(() => {
        logicRuleRef.current = logicRule;
    }, [logicRule]);

    const selectedObjRef = useRef(selectedObj);

    useEffect(() => {
        selectedObjRef.current = selectedObj;
    }, [selectedObj]);

    const sidepanelTypeRef = useRef(sidepanelType);

    useEffect(() => {
        sidepanelTypeRef.current = sidepanelType;
    }, [sidepanelType]);

    const updateModelData = (data: any) => {
        setModelData(data)
    }

    const updateSidePanelData = (data: any) => {
        setSidePanelData(data)
    }

    const updateFilteredData = (data: any) => {
        setFilteredData(data)
    }


    const openPickPanel = useCallback((type: string = "regular", index: number, rootIndex: number) => {
        setShowPickPanel(true);
        setSidepanelType(["left_exp", "right_exp"]?.includes(type) ? "math" : type)
        setSelectedObj({
            type: type,
            selectedRootIndex: rootIndex,
            selectedConditionIndex: index
        })
        // setSelectedIds([])

        setSelectedIds((prev: TNode[]) => {
            const logicRuleCurrent = logicRuleRef.current
            let newIds: TNode[] = [];
            switch (type) {
                case "source":
                    newIds = logicRuleCurrent?.rule?.source[rootIndex]?.condition[index]?.rule?.nodes?.map((x: any) => x) ?? []
                    break;
                case "left_exp":
                    newIds = logicRuleCurrent?.rule?.source[rootIndex]?.condition[index]?.rule?.left_exp?.map((x: any) => x) ?? []
                    break;
                case "right_exp":
                    newIds = logicRuleCurrent?.rule?.source[rootIndex]?.condition[index]?.rule?.right_exp?.map((x: any) => x) ?? []
                    break;
                case "target":
                    newIds = logicRuleCurrent?.rule[type]?.conditions?.map((x: any) => x) ?? []
                    break;
                default:
                    break;
            }
            return newIds;
        });
    }, [showPickPanel, sidepanelType, selectedIds])

    const hidePickPanel = () => {
        setShowPickPanel(false);
        setSelectedIds([])
    }

    const toggleTarget = () => {
        setShowTarget(prev => !prev);
    };


    const addLogicalCondition = useCallback(() => {
        setLogicRule((prev: any) => {
            // Create a new object to avoid mutating the previous state
            const newSource = [
                ...prev.rule.source,
                {
                    operator: "AND",
                    condition: [
                        {
                            operator: "AND",
                            type: "logicRule",
                            rule: {
                                operator: "all_true",
                                nodes: [],
                            },
                        },
                    ],
                },
            ];

            // Return a new object to ensure React can detect the state change
            return {
                ...prev,
                rule: {
                    ...prev.rule,
                    source: newSource,
                },
            };
        });
    }, [logicRule]);

    const addMathCondition = useCallback(() => {
        setLogicRule((prev: any) => {
            // Create a new object to avoid mutating the previous state
            const newSource = [
                ...prev.rule.source,
                {
                    operator: "AND",
                    condition: [
                        {
                            operator: "AND",
                            type: "mathexp",
                            rule: {
                                operator: "==",
                                left_exp: [],
                                right_exp: []
                            },
                        },
                    ],
                },
            ];

            // Return a new object to ensure React can detect the state change
            return {
                ...prev,
                rule: {
                    ...prev.rule,
                    source: newSource,
                },
            };
        });
    }, [logicRule]);


    const addNestedMathCondition = useCallback((index: number) => {
        setLogicRule((prev: any) => {
            // Create a new object to avoid mutating the previous state
            let newSource = [...prev.rule.source];
            newSource = newSource.map((src: any, srcIndex: number) => {
                if (srcIndex === index) {
                    src.condition = [...src.condition, {
                        operator: "AND",
                        type: "mathexp",
                        rule: {
                            operator: "==",
                            left_exp: [],
                            right_exp: []
                        },
                    },]
                }
                return src
            })

            // Return a new object to ensure React can detect the state change
            return {
                ...prev,
                rule: {
                    ...prev.rule,
                    source: newSource,
                },
            };
        });
    }, [logicRule]);


    const addNestedLogicalCondition = useCallback((index: number) => {
        setLogicRule((prev: any) => {
            // Create a new object to avoid mutating the previous state
            let newSource = [...prev.rule.source];
            newSource = newSource.map((src: any, srcIndex: number) => {
                if (srcIndex === index) {
                    src.condition = [...src.condition, {
                        operator: "AND",
                        type: "logicRule",
                        rule: {
                            operator: "all_true",
                            nodes: [],
                        },
                    },]
                }
                return src
            })

            // Return a new object to ensure React can detect the state change
            return {
                ...prev,
                rule: {
                    ...prev.rule,
                    source: newSource,
                },
            };
        });
    }, [logicRule]);

    const getNode = (item: TSidePanelData) => {
        return {
            type: FIELD_TYPES.includes(item?.type) ? "field" : item?.type.toLowerCase(),
            name: item?.name,
            field_type: item?.type,
            submodel: item?.submodel,
            category: item?.category,
            field: item?.field,
            submodelName: item?.submodelName,
            categoryName: item?.categoryName,
            fieldName: item?.fieldName,
            property: "logic_state",
            operator: "==",
            value: '1',
            id: item?.id
        }
    }

    const handleCheckBox = useCallback((submodel: any,field: any, item: any, checked: boolean) => {
        const setStateFunction = (prev: any) => {
            const selected = selectedObjRef.current;
            const node: TNode = getNode(item)
            type TKey = keyof typeof node;
            if (FIELD_TYPES.includes(item?.type)) {
                node.field = item?.id
            } else {
                node[item?.type as TKey] = item?.id
            }

            if (NODE_TYPES.includes(item?.type)) {
                delete node?.field_type
            }

            if (selected?.type === "source") {
                if (selected?.selectedRootIndex !== null && selected?.selectedRootIndex !== undefined) {
                    const currentConditions = prev?.rule?.source?.[selected?.selectedRootIndex]?.condition[selected?.selectedConditionIndex]?.rule?.nodes
                    const updatedList = checked
                        ? [...currentConditions, node]
                        : currentConditions?.filter((x: any) => {
                            if (x.type === 'choice') {
                                if (x.submodel === item.submodel && x.field === item.field && x.type === item.type && item.name === x.name) {
                                    return false;
                                } else {
                                    return true;
                                }
                            }
                            return (x.id !== item.id);
                        });

                    const newPrev = { ...prev };
                    newPrev.rule.source[selected?.selectedRootIndex].condition[selected?.selectedConditionIndex].rule.nodes = [...updatedList]
                    return newPrev;
                }
            } else {
                const currentConditions = prev?.rule?.target?.conditions
                const updatedList = checked
                    ? [...currentConditions, node]
                    : currentConditions?.filter((x: any) => {
                        console.log(x)
                        // return !(x.submodel === submodel && x.field === field && x?.id === item.id);
                        if (x.type === 'choice') {
                            if (x.submodel === item.submodel && x.field === item.field && x.type === item.type && item.name === x.name) {
                                return false;
                            } else {
                                return true;
                            }
                        }
                        return (x.id !== item.id);
                    });

                const newPrev = { ...prev };
                newPrev.rule.target.conditions = [...updatedList]
                return newPrev;
            }

            return prev;
        }

        setLogicRule(setStateFunction)

        setSelectedIds(prev => {
            const newIds = checked ? [...prev, item] : prev?.filter(x => {
                if (x.type === 'choice') {
                    if (x.submodel === item.submodel && x.field === item.field && x.type === item.type && item.name === x.name) {
                        return false;
                    } else {
                        return true;
                    }
                }
                return x.id !== item.id;
            });
            return newIds;
        });
    }, []);

    const handleMathExp = useCallback((item: any) => {
        const setStateFunction = (prev: any) => {
            const selected = selectedObjRef.current;
            const node: TNode = getNode(item)
            type TKey = keyof typeof node;

            if (FIELD_TYPES.includes(item?.type)) {
                node.field = item?.id
            } else {
                node[item?.type as TKey] = item?.id
            }

            if (NODE_TYPES.includes(item?.type)) {
                delete node?.field_type
            }
            if (selected?.selectedRootIndex !== null && selected?.selectedRootIndex !== undefined) {
                const currentConditions = prev?.rule?.source?.[selected?.selectedRootIndex]?.condition[selected?.selectedConditionIndex]?.rule[selected?.type]
                const updatedList = [...currentConditions, node]
                const newPrev = { ...prev };
                newPrev.rule.source[selected?.selectedRootIndex].condition[selected?.selectedConditionIndex].rule[selected?.type] = [...updatedList]
                return newPrev;
            }
            return prev;
        }
        setLogicRule(setStateFunction)

    }, []);


    const deleteLogicalCondtion = useCallback((rootIndex: number, index: number) => {
        setLogicRule((prev: any) => {
            if (rootIndex !== null && rootIndex !== undefined) {
                if (index > -1 && index < prev?.rule?.source?.[rootIndex]?.condition?.length) {
                    const newPrev = { ...prev }
                    if (newPrev?.rule?.source?.[rootIndex]?.condition?.length === 1) newPrev.rule.source.splice(rootIndex, 1)
                    newPrev?.rule?.source?.[rootIndex]?.condition?.splice(index, 1)
                    return newPrev
                }
            }
            return prev
        }
        )
        setSelectedIds([])
        setSelectedObj({
            selectedRootIndex: 0,
            type: 'source',
            selectedConditionIndex: 0
        })
        hidePickPanel()
    }, [])

    const deleteNodeInLogicalCondtion = useCallback((rootIndex: number, index: number, itemIndex: number, type: string) => {
        const setStateFunction = (prev: any) => {

            if (type === "source") {
                if (rootIndex !== null && rootIndex !== undefined && index !== null && index !== undefined) {
                    const currentConditions = Array.isArray(prev?.rule?.source[rootIndex]?.condition[index]?.rule?.nodes) ? prev?.rule?.source[rootIndex]?.condition[index]?.rule?.nodes : [];
                    const updatedList = currentConditions?.filter((x: any, xIndex: number) => xIndex !== itemIndex);
                    setSelectedIds(prevIds => {
                        const newIds = prevIds?.filter(node => {
                            if(node.type === 'choice') {
                                if (node.submodel === currentConditions[itemIndex]?.submodel && node.field === currentConditions[itemIndex]?.field && node.type === currentConditions[itemIndex]?.type && currentConditions[itemIndex]?.name === node.name) {
                                    return false;
                                } else {
                                    return true;
                                }
                            }
                            return node.id !== currentConditions[itemIndex]?.id;
                        })
                        return newIds;
                    });
                    const newPrev = { ...prev }
                    newPrev.rule.source[rootIndex].condition[index].rule.nodes = [...updatedList]
                    return newPrev
                }
            }
            else {
                const currentConditions = Array.isArray(prev?.rule?.target?.conditions) ? prev?.rule?.target?.conditions : [];
                const updatedList = currentConditions?.filter((x: any, xIndex: number) => xIndex !== itemIndex);
                setSelectedIds(prevIds => {
                    const newIds = prevIds?.filter(node => {
                        if(node.type === 'choice') {
                            if (node.submodel === currentConditions[itemIndex]?.submodel && node.field === currentConditions[itemIndex]?.field && node.type === currentConditions[itemIndex]?.type && currentConditions[itemIndex]?.name === node.name) {
                                return false;
                            } else {
                                return true;
                            }
                        }
                        return node.id !== currentConditions[itemIndex]?.id;
                    })
                    return newIds;
                });
                const newPrev = { ...prev }
                newPrev.rule.target.conditions = [...updatedList]
                return newPrev
            }
            return prev
        }

        setLogicRule(setStateFunction)
    }, [])


    const updateNodeInLogicalCondtion = useCallback((rootIndex: number, index: number, type: string, itemIndex: number, value: string, propName: string) => {

        const setStateFunction = (prev: any) => {

            if (type === "source") {
                if (rootIndex !== null && rootIndex !== undefined && index !== null && rootIndex !== undefined) {
                    const currentConditions = Array.isArray(prev?.rule?.source[rootIndex]?.condition[index]?.rule?.nodes) ? prev?.rule?.source[rootIndex]?.condition[index]?.rule?.nodes : [];
                    const updatedList = currentConditions?.map((x: any, xIndex: number) => {
                        if (xIndex === itemIndex) {
                            if (propName === "property") {
                                if (x.property !== value) {
                                    x.property = value
                                    x.value = value === "logic_state" ? 1 : ""
                                }
                            } else x[propName] = value
                        }
                        return x
                    });
                    const newPrev = { ...prev }
                    newPrev.rule.source[rootIndex].condition[index].rule.nodes = [...updatedList]
                    return newPrev
                }
            }
            else {
                const currentConditions = Array.isArray(prev?.rule?.target?.conditions) ? prev?.rule?.target?.conditions : [];
                const updatedList = currentConditions?.map((x: any, xIndex: number) => {
                    if (xIndex === itemIndex) {
                        if (propName === "property") {
                            if (x.property !== value) {
                                x.property = value
                                x.value = value === "logic_state" ? 1 : ""
                            }
                        } else x[propName] = value
                    }
                    return x
                });
                const newPrev = { ...prev }
                newPrev.rule.target.conditions = [...updatedList]
                return newPrev

            }
            return prev
        }

        setLogicRule(setStateFunction)
    }, [])


    const updateNodeInMathCondtion = useCallback((rootIndex: number, index: number, type: string, itemIndex: number, value: string, propName: string) => {

        const setStateFunction = (prev: any) => {

            if (rootIndex !== null && rootIndex !== undefined && index !== null && rootIndex !== undefined) {
                const currentConditions = Array.isArray(prev?.rule?.source[rootIndex]?.condition[index]?.rule[type]) ? prev?.rule?.source[rootIndex]?.condition[index]?.rule[type] : [];
                const updatedList = currentConditions?.map((x: any, xIndex: number) => {
                    if (xIndex === itemIndex) { 
                        if (propName === "name") {
                            x.name = prev.name === 'text' ? value : value.concat(value)
                        }
                        else {
                        x[propName] = value
                        }
                    }
                    return x
                });
                const newPrev = { ...prev }
                newPrev.rule.source[rootIndex].condition[index].rule[type] = [...updatedList]
                return newPrev
            }

            return prev
        }

        setLogicRule(setStateFunction)
    }, [])


    const deleteNodeInMathCondtion = useCallback((rootIndex: number, index: number, type: string, itemIndex: number) => {

        const setStateFunction = (prev: any) => {

            if (rootIndex !== null && rootIndex !== undefined && index !== null && index !== undefined) {
                const currentConditions = Array.isArray(prev?.rule?.source[rootIndex]?.condition[index]?.rule[type]) ? prev?.rule?.source[rootIndex]?.condition[index]?.rule[type] : [];
                const updatedList = currentConditions?.filter((x: any, xIndex: number) => xIndex !== itemIndex);

                const newPrev = { ...prev }
                newPrev.rule.source[rootIndex].condition[index].rule[type] = [...updatedList]
                return newPrev
            }

            return prev
        }

        setLogicRule(setStateFunction)
    }, [])

    const updateConstraints = (data: string) => {
        setLogicRule((prev: any) => {
            const newPrev = { ...prev }
            newPrev.rule.constraint = data
            return newPrev
        })
    }

    const updateLogicalOperator = (rootIndex: number, index: number, type: string, value: string) => {
        const setStateFunction = (prev: any) => {

            if (type === "source") {
                if (rootIndex !== null && rootIndex !== undefined && index !== null && rootIndex !== undefined) {
                    const newPrev = { ...prev }
                    newPrev.rule.source[rootIndex].condition[index].rule.operator = value
                    return newPrev
                }
            }
            else {
                const newPrev = { ...prev }
                newPrev.rule.target.operator = value
                return newPrev
            }
            return prev
        }

        setLogicRule(setStateFunction)
    }


    const updateOperator = (rootIndex: number, index: number, callType: string, value: string) => {
        const setStateFunction = (prev: any) => {
            if (rootIndex !== null && rootIndex !== undefined && index !== null && rootIndex !== undefined && callType === "inner") {
                const newPrev = { ...prev }
                newPrev.rule.source[rootIndex].condition[index].operator = value
                return newPrev
            } else {
                const newPrev = { ...prev }
                newPrev.rule.source[rootIndex].operator = value
                return newPrev
            }
        }
        setLogicRule(setStateFunction)
    }

    const updateSelectedObj = (data: TSelectedObj) => {
        setSelectedObj(data)
    }

    const onInputChangeHandler = (e: any, type: string) => {
        setLogicRule((prev: any) => {
            const newPrev = { ...prev }
            newPrev[type] = e
            return newPrev
        })
    };

    const handleSaveRule = async (projectId: string) => {
        try {
            const res = await saveRule({ ...logicRule, project: projectId })
            if (res?.data?.done === true) {
                toast.success("Rule saved successfully")
                setShowRulesMenu(false)
            } else {
                toast.error(res?.data?.message ?? '')
            }
        } catch (error) {
            toast.error("Rule save was unsuccessful")
        }   
    }

    const handleUpdateRule = async () => {
        try {
            const res = await updateRule(logicRule)
            if (res?.data?.done) {
                toast.success("Rule updated succesfully")
                setShowRulesMenu(false)
            }
        } catch (error) {
            toast.error("Rule update unsuccesfull")
        }   
    }

    const handleDeleteRule = (id: string) => {
        deleteRule(id)
    }

    const getRules = (projectId: string) => {
        return getRuleList(projectId)
    }

    const getRule = async (id: string) => {
        try {
            setLoading(true)
            const rule = await getRuleItem(id ?? logicRule?.id)
            if (rule?.data?.data)
                setLogicRule(rule?.data?.data)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
        finally {
            setLoading(false)
        }
    }

    return (
        <SB3RuleContext.Provider value={
            {
                modelData,
                sidePaneldata,
                handleCheckBox,
                selectedIds,
                showPickPanel,
                openPickPanel,
                hidePickPanel,
                sidepanelType,
                handleMathExp,
                updateModelData,
                updateSidePanelData,
                updateFilteredData,
                filteredData,
                toggleTarget,
                showTarget,
                onInputChangeHandler,
                deleteLogicalCondtion,
                deleteNodeInLogicalCondtion,
                handleSaveRule,
                handleUpdateRule,
                handleDeleteRule,
                getRule,
                getRules,
                updateConstraints,
                logicRule,
                addLogicalCondition,
                addMathCondition,
                addNestedMathCondition,
                addNestedLogicalCondition,
                updateSelectedObj,
                updateNodeInLogicalCondtion,
                updateNodeInMathCondtion,
                updateLogicalOperator,
                updateOperator,
                toggleMenu,
                showRulesMenu,
                updateLogicRule,
                deleteNodeInMathCondtion,
                selectedObj,
                resetLogicRule,
                loading
            }}>
            {children}
        </SB3RuleContext.Provider>
    );
}